import { useTranslation } from "react-i18next";
import { Label, Textarea, StringSelect } from "@tellescope/ui";
import type { TextBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import { StyleSection } from "../shared/StyleSection";
import type { BlockTypeEditorProps } from "../types";

type TextBlockEditorProps = BlockTypeEditorProps<TextBlock>;

export function TextBlockEditor({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  updateStyle,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
  styleOpen,
  setStyleOpen,
}: TextBlockEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t("Content")}</Label>
        <Textarea
          value={block.props.content}
          onChange={(e) => updateProps({ content: e.target.value })}
          placeholder={t("Enter text content...")}
          rows={4}
        />
      </div>
      <StringSelect
        label={t("Style")}
        value={block.props.variant}
        onValueChange={(value) => updateProps({ variant: value })}
        options={[
          { value: "body", label: t("Body") },
          { value: "caption", label: t("Caption") },
          { value: "muted", label: t("Muted") },
        ]}
      />
      <StyleSection style={block.style} onChange={updateStyle} open={styleOpen} onOpenChange={setStyleOpen} />
      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
}
